import { CreateTagDto, UpdateTagDto, TagDto } from '@sr/dto';
import { FormikErrors } from 'formik';
import { NotificationsConfig } from 'shared/ui/snack';
import { FormTools, VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';

export type FormValues = {
  name: string;
  color: string;
};

const initialValues: FormValues = {
  name: '',
  color: '#104fd7ff',
};

export const TagsNotificationsConfig: NotificationsConfig = {
  itemTitleForm1: 'тэги',
  itemTitleForm2: 'тэга',
  gender: 'male',
};

export const formTools: FormTools<TagDto, CreateTagDto, UpdateTagDto, FormValues> = {
  toCreateDto: (formData) => {
    return {
      name: formData.name,
      color: formData.color,
    };
  },

  toUpdateDto: (id, formData) => {
    return {
      id,
      name: formData.name,
      color: formData.color,
    };
  },

  fromDto: (item) => {
    return {
      name: item.name,
      color: item.color,
    };
  },

  emptyValues: () => {
    return initialValues;
  },

  validate: (values) => {
    const errors: FormikErrors<FormValues> = {};

    if (!values.name || values.name.length === 0) errors.name = VALIDATION_REQUIRED_FIELD;

    return errors;
  },
};
